import { createContext } from 'react'

export interface ICommunityContext {
  community?: MainSchema.Community
  noCommunity?: boolean
  communityLoading?: boolean
}

export default createContext<ICommunityContext>({})
